import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import SegmentLandingHelmet from 'common/helmets/SegmentLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';
import SegmentLogo from 'img/landing/canny-segment-integration.webp';
import Segment1 from 'img/landing/segment-1.webp';
import Segment2 from 'img/landing/segment-2.webp';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class SegmentLanding extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Segment Integration Page');
  }

  render() {
    return (
      <div className="integrationsLanding">
        <SegmentLandingHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage className="appLogo" loading="eager" src={SegmentLogo} />
              <div className="text">
                <h1 className="title">Segment for Canny</h1>
                <div className="subtitle">Sync user data from Segment to&nbsp;Canny</div>
                <div className="links">
                  <InstallExtensionButton
                    installButtonText="Install Segment"
                    installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fsegment"
                  />

                  <a
                    href="https://help.canny.io/en/articles/3567235-segment-integration"
                    rel="noopener"
                    target="_blank">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={Segment1} />
              </div>
              <div className="featureText">
                <div className="title">Rich user data—no&nbsp;code&nbsp;required</div>
                <div className="subtitle">
                  Segment will keep Canny updated with user traits to help you prioritize
                  their&nbsp;feedback.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={Segment2} />
              </div>
              <div className="featureText">
                <div className="title">Vote on behalf of any&nbsp;user</div>
                <div className="subtitle">
                  Syncing with user data in Segment means Canny will automatically populate
                  suggestions when{' '}
                  <a
                    href="https://help.canny.io/en/articles/636112-vote-on-behalf-of-your-users"
                    rel="noopener"
                    target="_blank">
                    voting on&nbsp;behalf
                  </a>
                  .
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default withContexts({
  trackEvent: TrackEventContext,
  viewer: ViewerContext,
})(SegmentLanding);
